import axios from 'axios';
import Auth from './auth';

function emptyTagReservaCtx() {
  return {
    elegivel: false,
    cnpjPossuiEstoque: false,
    saldoLiquido: 0,
    saldoContratual: 0,
    contractIds: [],
    saldoContratualByContract: {},
    saldoLiquidoByContract: {},
    isEligibleForContract: function () { return false; },
  };
}

class TagService {

  /**
  * Ativa tag para o veiculo
  * @param serialNumber
  * @param vehicleId
  * @returns Promise<Object> Lista veiculos
  */
 activateTag(serialNumber,vehicleId) {
   return axios
     .post('/v1/activateTag',{serialNumber:serialNumber,vehicleId:vehicleId}).then(r => {
       return r.data;
     });
 }

   /**
   * Ativa tag para o veiculo
   * @param serialNumber
   * @param vehicleId
   * @returns Promise<Object> Lista veiculos
   */
  activateTagGeneral(filter) {
    return axios
      .post('/v2/activateTagGeneral',filter).then(r => {
        return r.data;
      });
  }
     /**
   * Ativa tag para o veiculo
   * @param serialNumber
   * @param vehicleId
   * @returns Promise<Object> Lista veiculos
   */
  activateTagSite(req) {
    return axios
      .post('/v2/tag/activateTagSite',req).then(r => {
        return r.data;
      });
    }

   /**
   * Bloqueia a tag temporarimante
   * @param serialNumber
   * @param contractId
   * @param reason Motivo
   * @returns Promise<Object> Lista veiculos
   */
  blockTagTemp(serialNumber, reason) {
    return axios
      .post('/v2/blockTag',{serialNumber: serialNumber,reasonId: 8,reasonDescription: reason});
  }


   /**
   * Desbloqueia a tag
   * @param serialNumber
   * @param contractId
   * @returns Promise<Object> Lista veiculos
   */
  unblockTag(serialNumber, contractId, reason) {
    return axios
      .post('/v2/unblockTag',{serialNumber: serialNumber,contractId: contractId});
  }

  hasStockTagReserva(contractId) {
    return axios
      .get(`/v2/verificarDisponibilidadeTagReserva/${contractId}`)
      .then(r => r.data);
  }

  getSaldoTagReservaByMoveMaisId(moveMaisId) {
    return axios
      .get(`/v2/getSaldoTagReservaByMoveMaisId/${moveMaisId}`)
      .then(r => r.data && r.data.saldos ? r.data.saldos : [])
      .catch(() => []);
  }

  getTagReservaContexto() {
    const cnpj = Auth.currentUser && Auth.currentUser.taxIdNumber;
    const moveMaisId = Auth.currentUser && Auth.currentUser.moveMaisId;
    if (!cnpj || !moveMaisId) return Promise.resolve(emptyTagReservaCtx());

    return this.getSaldoTagReservaByMoveMaisId(moveMaisId)
      .then(saldos => {
        const entrada = (saldos || []).find(s => s && s.cnpj === cnpj);
        if (!entrada) return emptyTagReservaCtx();

        const contractIds = entrada.contractIds || [];
        const contractIdsStr = contractIds.map(c => String(c));
        const saldoContratual = Math.max(0, entrada.saldoContratualDisponivel != null ? entrada.saldoContratualDisponivel : 0);
        const saldoLiquido = Math.max(0, entrada.saldoDisponivelLiquido != null ? entrada.saldoDisponivelLiquido : 0);
        const saldoContratualByContract = {};
        const saldoLiquidoByContract = {};
        contractIds.forEach(cid => {
          saldoContratualByContract[cid] = saldoContratual;
          saldoLiquidoByContract[cid] = saldoLiquido;
        });

        return {
          elegivel: contractIds.length > 0,
          cnpjPossuiEstoque: true,
          saldoLiquido,
          saldoContratual,
          contractIds,
          saldoContratualByContract,
          saldoLiquidoByContract,
          isEligibleForContract: (cid) => cid != null && contractIdsStr.includes(String(cid)),
        };
      })
      .catch(() => emptyTagReservaCtx());
  }

  ativarTagEmMaos(payload) {
    return axios
      .post(`/v2/ativarTagEmMaos`, payload)
      .then(r => r.data);
  }

  /**
  * Substituir o tag
  * @param vehicleId
  * @param serialNumber
  * @param moveMaisId
  * @returns Promise<Object> Lista veiculos
  */
 replaceTagAggregate(filter) {
   return axios
   .post('/v2/tag/replaceTagAggregate', filter).then(res => {
     // res.data.forEach(function (o) {
       if (res.data.response == 1) {
         res.data.status.message = 'Veículo não encontrado';
       } else if (res.data.response == 2) {
         res.data.status.message = 'Contrato agregador não encontrado';
       } else if (res.data.response == 3) {
         res.data.status.message = 'Forma de pagamento não encontrada para o contrato';
       } else if (res.data.response == 4) {
         res.data.status.message = 'Tag não disponível no estoque correto';
       } else if (res.data.response == 5) {
         res.data.status.message = 'Erro ao inserir pedido';
       } else if (res.data.response == 6) {
         res.data.status.message = 'Erro ao inserir detalhes do pedido';
       } else if (res.data.response == 7) {
         res.data.status.message = 'Erro ao inserir envio do pedido';
       } else if (res.data.response == 8) {
         res.data.status.message = 'Erro ao vincular veículo ao pedido';
       } else if (res.data.response == 9) {
         res.data.status.message = 'Erro ao vincular tag ao pedido';
       } else if (res.data.response == 10) {
         res.data.status.message = 'Erro ao chamar a ativação da tag';
       } else if (res.data.response == 11) {
         res.data.status.message = 'Erro na ativação da tag';
       }
     // });
     return res.data;
   });
 }

}

// Singleton
const instance = new TagService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/tag.js